import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// RecipeDetail entry point - Mounts RecipeDetail component to WordPress
import React from 'react';
import ReactDOM from 'react-dom/client';
import '../styles/globals.css';
// Import RecipeDetail component
import RecipeDetail from '@/pages/RecipeDetail';
import { Toaster } from '@/components/ui/sonner';
// Mount function
function mountRecipeDetail() {
    var _a, _b;
    const mountPoint = document.getElementById('noads-recipe-root');
    if (!mountPoint) {
        console.warn('[React] RecipeDetail mount point not found');
        return;
    }
    // Get WordPress data
    const wpData = window.wpData || {};
    // Get recipe slug from URL parameter, WordPress data, or use default
    let recipeSlug = wpData.recipeSlug || wpData.slug;
    if (!recipeSlug) {
        // Try URL parameter: ?recipe=slug
        const urlParams = new URLSearchParams(window.location.search);
        recipeSlug = urlParams.get('recipe') || '';
        if (!recipeSlug) {
            // Extract from URL path (e.g., /recipes/my-recipe-slug/)
            const pathMatch = window.location.pathname.match(/\/(?:recipes|recipe)\/([^\/]+)/);
            if (pathMatch) {
                recipeSlug = pathMatch[1];
            }
            else {
                // Try to get from mount point data attribute
                recipeSlug = mountPoint.dataset.recipeSlug || mountPoint.dataset.slug || '';
                // Default to mock recipe for testing if still no slug
                if (!recipeSlug) {
                    recipeSlug = 'herb-crusted-chicken';
                }
            }
        }
    }
    // Navigation handler for WordPress
    const handleNavigate = (page, recipeSlug) => {
        // Handle recipe-detail navigation with slug
        if (page === 'recipe-detail' && recipeSlug) {
            window.location.href = `/recipes/${recipeSlug}/`;
            return;
        }
        const pageMap = {
            home: '/',
            catalog: '/categories',
            'design-system': '/design-system',
            login: '/login',
            menu: '/menu',
            'recipe-box': '/recipe-box',
            recipes: '/recipes',
            profile: '/profile',
            'shopping-list': '/shopping-list',
        };
        // For catalog, try multiple slugs in order of preference
        if (page === 'catalog') {
            const catalogSlugs = ['/catalog', '/categories', '/generic-catalog'];
            // Try the first slug (WordPress will handle 404 if it doesn't exist)
            window.location.href = catalogSlugs[0];
            return;
        }
        const url = pageMap[page] || '/';
        window.location.href = url;
    };
    // Create root and render
    const root = ReactDOM.createRoot(mountPoint);
    root.render(_jsxs(React.StrictMode, { children: [_jsx(RecipeDetail, { slug: recipeSlug || '', onNavigate: handleNavigate, onQuizClick: () => { }, menuItems: ((_a = wpData.menus) === null || _a === void 0 ? void 0 : _a.primary) || [], siteName: wpData.siteName, footerMenuItems: ((_b = wpData.menus) === null || _b === void 0 ? void 0 : _b.footer) || [] }), _jsx(Toaster, {})] }));
}
// Auto-mount when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountRecipeDetail);
}
else {
    mountRecipeDetail();
}
// Export for manual mounting if needed
export { mountRecipeDetail };
